//企业参与国家标准或行业标准制定情况明细
import {useState} from "react";
import {Form, Input, Descriptions, Button, Radio, Select, Table, Space, DatePicker} from "antd";
import {gql, useMutation, useSubscription} from "@apollo/client";

const {TextArea} = Input;
export default function Hyzdmx() {
    const [value, setValue] = useState(window.location.hash.split("?")[1] || '');

    const handleChange = (newValue) => {
        setValue(newValue);
        window.location.hash = (window.location.hash.split("?")[0] || window.location.hash) + '?' + newValue
    };

    const [form] = Form.useForm();
    const {data: theRDData, loading: theMndsbDataLoading} = useSubscription(
        gql`subscription MySubscription($id: uuid = "") {
            hyzdmx_by_pk(id: $id) {
                blevel
                bname
                bnumber
                created_at
                id
                mndsb
                pway
                updated_at
                mndsbObj {
                    _glykj
                    _jscxgl
                    _kjcgzh
                    _zscqjz
                    basics_cost
                    china_cost
                    company
                    created_at
                    ent_hr_abroed
                    ent_hr_age1
                    ent_hr_age2
                    ent_hr_age3
                    ent_hr_age4
                    ent_hr_bachelor
                    ent_hr_doctor
                    ent_hr_ext
                    ent_hr_forg
                    ent_hr_junior
                    ent_hr_master
                    ent_hr_mechanic
                    ent_hr_middle
                    ent_hr_on_job
                    ent_hr_part
                    ent_hr_primary
                    ent_hr_senior
                    ent_hr_total
                    ent_hr_tsdplan
                    enterprise_income
                    id
                    net_asset1
                    net_asset3
                    net_asset2
                    year
                    updated_at
                    total_profit3
                    total_profit2
                    total_profit1
                    sat_hr_tsdplan
                    sat_hr_total
                    sat_hr_part
                    sat_hr_on_job
                    sat_hr_forg
                    sat_hr_ext
                    sat_hr_abroed
                    sales_revenue3
                    sales_revenue2
                    sales_revenue1
                    hyzdmxs {
                        blevel
                        bname
                        bnumber
                        created_at
                        id
                        mndsb
                        pway
                        updated_at
                    }
                }
            }
        }

        `, {
            variables: {id: value},
            shouldResubscribe: true
        },
    )
    const [update_hyzdmx_by_pk, {error}] = useMutation(gql`mutation MyMutation($id: uuid = "", $hyzdmx:hyzdmx_set_input = {}) {
        update_hyzdmx_by_pk(pk_columns: {id: $id}, _set: $hyzdmx) {
            id
        }
    }
    `);
    const hyzdmxInitialValues = {...(theRDData || {}).hyzdmx_by_pk};
    return (<>
            {(theRDData || {}).hyzdmx_by_pk && <>
                <Form
                    name="basic"
                    labelCol={{
                        span: 32,
                    }}
                    wrapperCol={{
                        span: 32,
                    }}
                    style={{
                        maxWidth: 800,
                    }}
                    initialValues={hyzdmxInitialValues}
                    onFinish={(values) => {
                        console.log(values)
                        update_hyzdmx_by_pk({
                            variables: {
                                id: value,
                                hyzdmx: values
                            }
                        }).fankui().then(value1 => window.history.back())

                    }}
                    onFinishFailed={(e) => {
                        console.error(e)
                    }}
                    autoComplete="off"
                    form={form}
                >
                    <Form.Item
                        label="标准名称"
                        name="bname"
                        rules={[{required: true, message: '请输入内容'}]}
                        style={{display: 'inline-flex', width: '50%'}}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="标准级别"
                        name="blevel"
                        rules={[{required: true}]}
                        style={{display: 'inline-flex', width: '50%'}}
                    >
                        <Radio.Group>
                            <Radio value="国家">国家</Radio>
                            <Radio value="行业">行业</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        label="标准编号"
                        name="bnumber"
                        rules={[{required: true, message: '请输入内容'}]}
                        style={{display: 'inline-flex', width: '50%'}}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="参与方式"
                        name="pway"
                        rules={[{required: true}]}
                        style={{display: 'inline-flex', width: '50%'}}
                    >
                        <Radio.Group>
                            <Radio value="主持">主持</Radio>
                            <Radio value="参与">参与</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item wrapperCol={{offset: 8, span: 8}}>
                        <Button type="primary" htmlType="submit">
                            确定
                        </Button>
                    </Form.Item>
                </Form>


            </>}
        </>
    )
}
